import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import distributionStatuses from "astrid-firestore/src/api/distribution/constants/distributionStatuses";

const retryPipeline = firebase.functions().httpsCallable("distribution-retryPipeline");

export default function useExportDropdownMenuOptions() {
	const { t } = useTranslation();

	return (theExport) => [
		{
			text: t("retry", "Retry"),
			hidden: !theExport?.jobId,
			action: () => {
				return retryPipeline({ collectionId: "exports", documentId: theExport.id });
			},
		},
	];
}
